import { SvgProps } from '../../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const ChevronLeft = ({ size, onClick }: SvgProps) => {
  return (
    <svg
      onClick={onClick}
      {...stylex.props(styles.base, styles[size])}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      data-testid="ChevronLeft"
      fill="none"
    >
      <path
        {...stylex.props(styles.base)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697L15.2197 3.96967C15.5126 3.67678 15.9874 3.67678 16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L9.31066 12L16.2803 18.9697C16.5732 19.2626 16.5732 19.7374 16.2803 20.0303C15.9874 20.3232 15.5126 20.3232 15.2197 20.0303L7.71967 12.5303Z"
        fill="#1D252D"
      />
    </svg>
  );
};

export default ChevronLeft;
